import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { MobileScrollToService } from '../../../../shared/services/mobile-scroll-to.service';

@Component({
    selector: 'payment-delivery-addresses-zip-code',
    templateUrl: './payment.delivery.zip-code.component.html',
    styleUrls: ['../../../payment.component.scss']

})
export class PaymentDeliveryAddressesZipCodeComponent implements AfterViewInit {
    public zipCodeModel = '';
    @Output() zipCodeInputted: EventEmitter<string> = new EventEmitter();
    @Output() activated: EventEmitter<null> = new EventEmitter();

    constructor(private mobileScrollToService: MobileScrollToService) {}

    ngAfterViewInit() {
        this.activated.emit();
        this.mobileScrollToService.scrollTo('#scroll-to-delivery-zip-code');
    }

    /**
     * This emit zip code inputted event to pass zipCodeModel value to
     * another components.
     **/
    public next() {
        this.zipCodeInputted.emit(this.zipCodeModel.replace(/\D/g, ''));
    }

    /**
     * If zip code fulfilled, then go to next step.
     **/
    public onKeyUp() {
        if (this.zipCodeModel.replace(/\D/g, '').length === 8) {
            this.next();
        }
    }

    /**
     * Load zip code mask pattern.
     * */
    public loadZipCodeMask() {
        return [
            /\d/, /\d/, /\d/, /\d/, /\d/, '-',
            /\d/, /\d/, /\d/
        ];
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/payment/delivery/addresses/zip-code/payment.delivery.zip-code.component.ts